import {Injectable} from '@angular/core';
import { UserProfileModel } from "./userprofile.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class UserProfileService {

    private static uploadavatarUrl: string = '/api/account/uploadavatar';
    private static updateprofileUrl: string = '/api/account/updateprofile';
    private static getprofileUrl: string = '/api/account/getprofile';

    constructor(private http: HttpClient) {
    }

    public getUserProfile(): Observable<any> {
        return this.http.get<any>(UserProfileService.getprofileUrl);
    }

    public updateUserProfile(userProfile: UserProfileModel): Observable<any> {
        return this.http.post<any>(UserProfileService.updateprofileUrl, userProfile);
    }

    public updateUserProfileImage(image: any): Observable<any> {
        let headers = new HttpHeaders()
            .set('cache-control', 'no-cache');
        return this.http.post<any>(UserProfileService.uploadavatarUrl, image, { headers: headers });

    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/profile/userprofile.service.ts